// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3dMe9","calendarButtons":"ClockData_calendarButtons__3HhFW"};